import React, {useState, useEffect, useRef} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {ImagesUrl, ServerUrl, Token, config, schoolName} from '../component/include'
import Select from 'react-select'
import { getClassField, getClassName, longDate} from '../component/globalFunction'
import { userToken } from '../component/authentication'
import Error403 from '../settings/error403'
import { useLocation } from 'react-router-dom'
import { verifyRouter } from '../component/authentication'
import { useDispatch, useSelector } from 'react-redux'

const ClassSummary =()=> {
    const structure = useRef(null)
    const [errors, setErrors] = useState({});
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    
    const [allResult, setAllResult]=useState([])
    let location =  useLocation()
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const schoolInfo  = useSelector(state => state.rootReducer.schoolInfo);
    const [result, setResult] = useState({
        studentClass:[],
        studentSection:[],
        orderBy:{value:' order by studentName ASC', label:'order by Name'}
    })

    const [stat, setStat] = useState({
        male:0,
        female:0,
        total:0
    })
  


const  handleFetchClass =()=>{

    const fd = new FormData();
    fd.append('jwt', Token)
       let url = ServerUrl + '/fetchField/tbl_school_class/schoolClass/ID/1';
       axios.post(url, fd, config)
       .then(result =>{
  
    let sqls = "SELECT classID, sectionID, sum(case when gender = 'Male'   then 1 else 0 end) AS 'Male', sum(case when gender = 'Female'  then 1 else 0 end) AS 'Female'  from tbl_students  where  admissionStatus='Studying' GROUP by sectionID order by sectionID ASC"
              
               const fds = new FormData();
               fds.append("sql", sqls);
               fds.append('jwt', Token)
               let urls = ServerUrl+'/fetchBySql_controller';
               axios.post(urls, fds, config).then(response=>{
                      let sec = getAllSection(result.data)
                    var final = sortResult(response.data, sec, result.data)
if(final.length>0){
    var female = final.reduce((accumulator, currentValue)=>Number(accumulator)+Number(currentValue.female), 0)
    var male = final.reduce((accumulator, currentValue)=>Number(accumulator)+Number(currentValue.male), 0)



 setAllResult(final.sort((a, b) =>(Number(a.order) > Number(b.order)) ? 1 : -1)) 
                 setStat({
                    female:female,
                    male:male,
                    total:male+female
                })
            }

            })
          })
       .catch((error)=>Alerts('Error!', 'danger', JSON.stringify(error.message))) 
           
   }

   const getAllSection =(school)=>{
    let section = []
    var newClass = [...school];
  
     for (var i in newClass){
            if(newClass[i].section[0].sname === ''){   
            section.push({classID:newClass[i].ID, sectionID:newClass[i].ID})
            } else{ 
                for(var k in newClass[i].section){
                    section.push({classID:newClass[i].ID, sectionID:newClass[i].section[k].ID})
                    }
        } 
    } 
  
    return section
  }

  const sortResult =(data, section, classes)=>{
    let result = []
    for(var k in section){

    for(var i in data){
        if(data[i].sectionID===section[k].sectionID){
        result.push({label:String(getClassName(section[k].classID,section[k].sectionID, classes)), male:data[i].Male, female:data[i].Female, total:Number(data[i].Male)+Number(data[i].Female), order:getClassField(section[k].classID, classes, 'order')})
      }
    }
      }
return result;
  }

   useEffect(()=>{
    //setIsAuthenticated(verifyRouter(location.pathname))
    handleFetchClass()
},[]);

        return (   <>
            <div  className="main-body">
            {isAuthenticated?   <div className="page-wrapper">
                          {notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Class Summary Report">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-file-text"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Students</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Class Summary</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

          




<div className="card z-depth-0">
		<div className="card-block">
	
                       <div className="row" >

                       {schoolInfo&&schoolInfo.map((st, id)=>
                       <table className='table'  key={id}>
       <tbody>
                <tr>
                    <td className="text-center" ><img id="viewSchoolLogo2" className="img-100" onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/${st.schoolLogo}`}  title="School Logo" alt=''  />
<h4 style={{textAlign:'center'}}><b>{st.schoolName}</b></h4>
<h6 style={{textAlign:'center'}}><b>Motto: {st.schoolMotto}</b></h6>
<div style={{textAlign:'center'}}>  {st.address}  </div>
<span style={{textAlign:'center'}}> {st.mobile}, {st.altMobile}, {st.email} </span>
 </td>
                </tr>
            </tbody>
       </table>  )}

</div> 
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b>CLASS POPULATION SUMMARY  </b></u></h5>
        </div></div><br/>



<div className="row">
<div className="col-md-12 table-responsive">
        <table className="table table-striped table-bordered  table-full-width">
    

            <thead>
                <tr>
                <th>SN</th>
                <th>Class</th>
                    <th>No. of Male</th>
                    <th>No. of Female</th>
                    <th>Total</th>

                </tr>
            </thead>
            <tbody>{allResult.length!==0? allResult.map((row, idx)=>
            
            <tr key={idx}>
                    <td>{idx+1}</td>
                    <td>{row.label}</td>
                    <td>{row.male}</td>
                    <td>{row.female}</td>
                    <td>{row.total}</td>
                </tr>): <TableLoader />}
            </tbody> 
            <tfoot>
            <tr>
                    <td colSpan={2} >Total</td>
                    <td > <b> {stat.male}</b></td>
                    <td ><b> {stat.female}</b></td>
                    <td ><b>{stat.total}</b></td>
                </tr>
            </tfoot>
        </table>
 </div>	 </div> 

 <div ref={structure} className="row no-print">
        <div className="col-md-12">
       

       
        <form method='POST' action={ServerUrl+'/printout/class_summary.php?token='+userToken} target='_blank' className='pull-right' >
                <input type='hidden' name='jwtToken' value ={Token} />
                <input type='hidden' name='allResult' value ={JSON.stringify(allResult, null, 2)} />
                <input type='hidden' name='stat' value ={JSON.stringify(stat, null, 2)} />
               
                <button type="submit" className="btn btn-inverse  " > <i className="fa fa-print"></i> Print</button>
        
        </form>
        </div></div>

 </div>
        </div>




   </div>
          {/* The Page Body close here */}

            </div>:
            <Error403 />}
            </div>

</> 
 );
        
}

export default React.memo(ClassSummary) 